import { Link } from '@reach/router';
import { fixBfcacheProblem, setupRouterLink } from '@smile-next/uikit';

fixBfcacheProblem();

setupRouterLink(Link);
